import { Box, Button, Card, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { UploadSimple, X } from "@phosphor-icons/react";
import React, { Fragment, useState } from "react";
import { GenericIconButton } from "../../components/generic/GenericIconButton";
import useStore from "../../states/store";
import { GenericDialog } from "../../components/generic/GenericDialog";
import { GenericCircleIcon } from "../../components/generic/GenericCircleIcon";

export const DownloadAppPopUp = () => {
  const [, { setShowDownloadPopUp }] = useStore();
  const [openDownloadInstructionDialog, setOpenDownloadInstructionDialog] = useState(false);

  const handleToggleDownloadInstructionDialog = (isOpen = true) => {
    setOpenDownloadInstructionDialog(isOpen);
    if (!isOpen) setShowDownloadPopUp(false);
  };

  const DialogHeader = () => {
    return <Typography ml={1} mt={0.2} variant="subtitle1" fontWeight={800}>Get WannaCollab as a Mobile App!</Typography>
  };

  return (
    <Fragment>
      <Card
        sx={{
          position: 'fixed',
          bottom: 16,
          left: '16px',
          right: '16px',
          width: 'calc(100% - 32px)',
          padding: '16px 12px 20px 12px',
          zIndex: 1000,
          boxShadow: '-4px 4px 20px rgba(0, 0, 0, 0.40)',
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          transform: 'translateY(0)',
          transition: 'transform 0.3s ease-out',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backdropFilter: 'blur(12px)',
            borderRadius: '10px',
            zIndex: -1,
          },
        }}
      >
        <Grid container >
          <Grid item size={11.9}>
            <Stack gap={1.6} alignItems={'center'}>
              <DialogHeader />
              <Button variant="contained" className="longButton" size="large" onClick={() => handleToggleDownloadInstructionDialog()}>Download WannaCollab</Button>
            </Stack>
          </Grid>
          <Grid
            item
            size={0.1}
            display="flex"
            justifyContent="flex-end"
            alignSelf="flex-start"
          >
            <GenericIconButton icon={<X size={24} />} onClick={() => setShowDownloadPopUp()} />
          </Grid>
        </Grid>
      </Card>
      <GenericDialog
        padding={'22px 16px'}
        openDialog={openDownloadInstructionDialog}
        handleClose={() => handleToggleDownloadInstructionDialog(false)}
        mb={0}
      >
        <Box sx={{ padding: '0px 24px' }}>
          <DialogHeader />
          <Stack gap={1} mt={2}>
            <Typography variant="subtitle1">1. In your browser toolbar</Typography>
            <Stack direction={'row'} alignItems={'center'} gap={1}>
              <Typography variant="subtitle1">2. Click this icon</Typography>
              <GenericCircleIcon size="30px">
                <UploadSimple size={20} />
              </GenericCircleIcon>
            </Stack>
            <Typography variant="subtitle1" mb={2}>3. Click &quot;Add to Home Screen&quot;</Typography>
            <Button variant="contained" onClick={() => handleToggleDownloadInstructionDialog(false)}>Done</Button>
          </Stack>
        </Box>
      </GenericDialog>
    </Fragment>
  );
};